import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const DrawingViewerPanel = ({ drawingUrl, isPdf, loading }) => {
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96 bg-surface rounded-lg border border-border">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (!drawingUrl) {
    return (
      <div className="flex flex-col items-center justify-center h-96 bg-surface rounded-lg border border-border text-text-secondary">
        <Icon name="FileX" size={48} className="mb-3 opacity-40" />
        <p className="text-sm">{t('noFileAvailable')}</p>
      </div>
    );
  }

  return (
    <div className="bg-surface rounded-lg border border-border overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="FileText" size={16} className="text-accent" />
          <span className="text-sm font-medium text-text-primary">{t('drawingViewer')}</span>
        </div>
        <a
          href={drawingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-xs text-accent hover:underline"
        >
          <Icon name="ExternalLink" size={13} />
          {t('openInNewTab')}
        </a>
      </div>
      <div className="w-full" style={{ minHeight: '520px' }}>
        {isPdf ? (
          <iframe
            src={drawingUrl}
            title={t('drawingPdf')}
            className="w-full"
            style={{ height: '520px', border: 'none' }}
          />
        ) : (
          <div className="flex items-center justify-center p-4 bg-gray-50" style={{ minHeight: '520px' }}>
            <img
              src={drawingUrl}
              alt={t('drawingPreview')}
              className="max-w-full max-h-[500px] object-contain rounded shadow"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DrawingViewerPanel;
